import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { openedRetrievedFAQArticle, openedDefaultFAQArticle } from "store/actions/diagnosticsActions";
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { FAQArticleLinkProps } from "models/propTypes/supportIssuePropTypes";
//#endregion
//#region components
import { Icon } from "components/common";
import { Grid } from "@mui/material";
import useFAQArticleLink from "../useGetFAQArtileLink";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const FAQArticleLink: React.FC<FAQArticleLinkProps> = (props) => {
  const { article, display } = props;
  const dispatch = useDispatch();

  const { getFAQUrl } = useFAQArticleLink();

  const onClick = () => {
    if (article.id === undefined) dispatch(openedDefaultFAQArticle());
    else dispatch(openedRetrievedFAQArticle(article.id));

    window.open(getFAQUrl(article.url ?? ""), "_blank");
  };

  return (
    <Grid
      container
      item
      direction="row"
      wrap="nowrap"
      className={clsx(cssExports.link, cssExports.faqLink, display === "filled" && cssExports.filled)}
      columnGap={2}
      onClick={onClick}
    >
      <Grid item xs>
        {article.title}
      </Grid>
      <Grid item container className={cssExports.icon} alignItems="center" xs="auto">
        <Icon icon={IconDefinitionConstants.WOpenExternal} />
      </Grid>
    </Grid>
  );
};

export default FAQArticleLink;
